import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { colors, gradient, greys } from "@styles/color.styles";
import spacing from "@styles/spacing.styles";

export const card: CSSProperties = {
  position: "relative",
  display: "flex",
  flexDirection: "row",
  borderRadius: 5,
  color: greys.white,
  background: gradient,
  marginBottom: 20,

  "@media (max-width: 768px)": {
    display: "none",
  },
};

export const cardContent: CSSProperties = {
  flex: 1,
  padding: 15,
};

export const cardBody: CSSProperties = {
  marginTop: 20,
  color: greys.white,
};

export const ctaButton: CSSProperties = {
  border: "none",
  borderRadius: 24,
  lineHeight: "24px",
  padding: "0 24px",
  paddingRight: 8,
  paddingTop: 8,
  paddingBottom: 6,
  boxShadow: "none",
  color: colors.blueSky.darker,
  backgroundColor: greys.white,
  display: "inline-block",
  verticalAlign: "middle",

  "&:hover": {
    backgroundColor: greys.paleGrey,
  },
};

export const ctaButtonIcon: CSSProperties = {
  marginLeft: spacing.std,
  paddingBottom: 2,
};

export const ctaButtonLabel: CSSProperties = {
  display: "flex",
};

export const dismissIcon: CSSProperties = {
  cursor: "pointer",
  position: "absolute",
  right: 10,
  top: 10,
};

export const h6: CSSProperties = {
  color: greys.white,
  marginRight: 24,
  lineHeight: "40px",
  verticalAlign: "middle",
  fontSize: 19,
  display: "inline",
};

export const styles = {
  card,
  cardContent,
  cardBody,
  ctaButton,
  ctaButtonIcon,
  ctaButtonLabel,
  dismissIcon,
  h6,
};
